/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Email_PlaceholderInputs */



/**
* | output |
* | --- |
* | "user@example.com" |
*
* @param {User_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_email_placeholder = /** @type {((inputs?: User_Email_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Email_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("utilisateur@exemple.com")
	if (locale === "es") return /** @type {LocalizedString} */ ("usuario@ejemplo.com")
	if (locale === "pt") return /** @type {LocalizedString} */ ("usuario@exemplo.com")
	if (locale === "it") return /** @type {LocalizedString} */ ("utente@esempio.com")
	return /** @type {LocalizedString} */ ("user@example.com")
});